import type {User} from '@/src/entities/user/types'

/** Public session contract. Backend credentials and JWT claims stay server-side. */
export type ClientSession = {
  user?: User
  updated_at?: string
  hasPhpSession: boolean
}

export function toClientSession(session: Session | ClientSession | null | undefined): ClientSession | null {
  if (session == null) return null
  return {
    user: session.user,
    updated_at: session.updated_at,
    hasPhpSession: Boolean(session.hasPhpSession || ('phpSessionId' in session && session.phpSessionId)),
  }
}
